import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  UserMatterHistoryDto,
  UserRequestHistoryDto,
  UserResourceHistoryDto,
} from '../models/user-history.models';

@Injectable({
  providedIn: 'root',
})
export class UserHistoryService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/api/userhistory`;

  /**
   * Get matter detail history for the current user
   * @param count Optional maximum number of records to return
   * @returns Observable of user matter history records
   */
  getMatterDetailHistory(count?: number): Observable<UserMatterHistoryDto[]> {
    let params = new HttpParams();

    if (count !== undefined) {
      params = params.set('count', count.toString());
    }

    return this.http
      .get<UserMatterHistoryDto[]>(`${this.apiUrl}/matter-details`, { params });
  }

  /**
   * Get request detail history for the current user
   * @param count Optional maximum number of records to return
   * @returns Observable of user request history records
   */
  getRequestDetailHistory(count?: number): Observable<UserRequestHistoryDto[]> {
    let params = new HttpParams();

    if (count !== undefined) {
      params = params.set('count', count.toString());
    }

    return this.http
      .get<UserRequestHistoryDto[]>(`${this.apiUrl}/request-details`, {
        params,
      });
  }

  /**
   * Get resource detail history for the current user
   * @param count Optional maximum number of records to return
   * @returns Observable of user resource history records
   */
  getResourceDetailHistory(
    count?: number
  ): Observable<UserResourceHistoryDto[]> {
    let params = new HttpParams();

    if (count !== undefined) {
      params = params.set('count', count.toString());
    }

    return this.http
      .get<UserResourceHistoryDto[]>(`${this.apiUrl}/resource-details`, {
        params,
      });
  }
}
